export default "__VITE_ASSET__dec33979__"